
export const actionOptions = {
 // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
 // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  "Y": [    
    {
      title: "Edit",
      cls: "edit-discounts",
      icon: "wrench",
      disabled: false
    },
	{
      title: "Deactivate",
      cls: "deactivate-discounts",
      icon: "toggle-off",
      disabled: false
    }
  ],
  "N": [
    {
      title: "Activate",
      cls: "activate-discounts",
      icon: "toggle-on",
      disabled: false
    }
  ],
  "D": [    
    {
      title: "Edit",
      cls: "edit-discounts",
      icon: "wrench",
      disabled: false
    },{
      title: "Duplicate",
      cls: "duplicate-discounts",
      icon: "clone",
      disabled: false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/discounts/filter/actionOptions.js